import React from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import PlanDetailsScreen from "./PlanDetailsScreen";
import { RootState } from "../../../redux/rootReducers";

const PlanDetailsScreenWrapper = () => {
  const { planId } = useParams<{ planId: string }>();
  const authApi = useSelector((state: RootState) => state.authReducer);

  if (!planId || !authApi.token) return null;

  return <PlanDetailsScreen planId={planId} token={authApi.token} />;
};

export default PlanDetailsScreenWrapper;
